import { render, staticRenderFns } from "./StaffEventCalendar.vue?vue&type=template&id=b037ca84&scoped=true"
import script from "./StaffEventCalendar.vue?vue&type=script&lang=js"
export * from "./StaffEventCalendar.vue?vue&type=script&lang=js"
import style0 from "./StaffEventCalendar.vue?vue&type=style&index=0&id=b037ca84&prod&scoped=true&lang=css"
import style1 from "./StaffEventCalendar.vue?vue&type=style&index=1&id=b037ca84&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b037ca84",
  null
  
)

export default component.exports